export default {"src":"/_next/static/media/mail-option.3bd00f6c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};